module.exports = __webpack_public_path__ + "static/media/total_devices.b1e71e08.svg";